export const IMAGE_LIST_SUCCESS = "IMAGE_LIST_SUCCESS";
export const IMAGE_LIST_LOADING = "IMAGE_LIST_LOADING";
export const IMAGE_UPLOAD_LOADING = "IMAGE_UPLOAD_LOADING";
